import { apiRequest } from "./common";

const getScoreGraph = async (semester, testType, type, studentId, subService) => {
    const response = await apiRequest('get', `/student-score/graph/${testType}?type=${type}&studentId=${studentId}${semester ? `&semester=${semester}` : ''}${subService ? `&studentSubjectId=${subService}` : ''}`);
    return response.data;
};

const createStudentScore = async (data) => {
    const response = await apiRequest('post', `/student-score`, data);
    return response.data;
};

const getScoreStats = async (type, studentId, subService) => {
    const response = await apiRequest('get', `/student-score/stats/${type}?studentId=${studentId}${subService ? `&studentSubjectId=${subService}` : ''}`);
    return response.data;
};

export {
    getScoreGraph,
    createStudentScore,
    getScoreStats
}